import analyticsLogo from '../../../assets/images/analyticsforschools_logo.png'
import { format, isValid } from 'date-fns'
import Typography from '@mui/material/Typography'
import { useDispatch, useSelector } from 'react-redux'
import { setDate } from '../../../store/actions/date.actions'
import { useCallback, useEffect } from 'react'
import { getDate } from '../../../services/date/date.service'

const Footer = ({ className }) => {
  const date = useSelector((state) => state?.date?.date)
  const dispatch = useDispatch()

  const loadData = useCallback(async () => {
    if (!isValid(date)) return
    const result = await getDate()
    dispatch(setDate(result.data))
  }, [])

  useEffect(() => {
    loadData()
  }, [loadData])

  return (
    <footer className={className}>
      <img className='dashboard-footer-image' src={analyticsLogo} alt='analytics_logo' />
      <Typography variant='inherit' className='dashboard-footer-text'>
        {`© 2019-${format(new Date(date ?? 0), 'yyyy')}. Analytics for Schools. All rights reserved | v${__APP_VERSION__}`}
      </Typography>
    </footer>
  )
}
export default Footer
